module.exports = {
      id: "pause-usage",
      viewBox: "0 0 31 30",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#pause",
      toString: function () {
        return this.url;
      }
    }